import { parseISO, isAfter, isBefore, startOfDay, endOfDay } from "date-fns";
import { WorkItemList } from "../store/services/timelineApiRTK";
import { DateFilter } from "../types/ActivityList.types";


export const getTeamColor = (teamId: number | undefined): string => {
  const colors: Record<number, string> = {
    1: "#3f51b5",
    2: "#f44336", 
    3: "#4caf50",
    7: "#ff9800",
    18: "#2196f3",
    24: "#9c27b0",
    28: "#9c27b0",
  };
  if (!teamId) return "#607d8b";
  return colors[teamId] || "#607d8b";
};

export const isOverdue = (item: WorkItemList): boolean => {
  if (!item.ScheduledTo) return false;
  const scheduledDate = parseISO(item.ScheduledTo);
  const now = new Date();
  return scheduledDate < now && item.State === 1;
};

export const isWithinDateRange = (item: WorkItemList, dateFilter: DateFilter): boolean => {
  if (!item.ScheduledTo) return !dateFilter.from && !dateFilter.to;
  
  const itemDate = parseISO(item.ScheduledTo);
  
  if (dateFilter.from && isBefore(itemDate, startOfDay(dateFilter.from))) {
    return false;
  }
  
  if (dateFilter.to && isAfter(itemDate, endOfDay(dateFilter.to))) {
    return false;
  }
  
  return true;
};